/* eslint-disable */
import { IsAzAccount } from 'modules';
import ArizonaDefaultLayerPanel from './ArizonaPublicLayerPanel/ArizonaPublicLayerPanel';
import ArizonaLayerPanel from './ArizonaLayerPanel/ArizonaLayerPanel';
import DefaultLayerPanel from './DefaultLayerPanel/DefaultLayerPanel';
import ArizonaDefaultMapPanel from './ArizonaDefaultMapPanel/ArizonaDefaultMapPanel';
import ArizonaPublicLayerPanel from './ArizonaPublicLayerPanel/ArizonaPublicLayerPanel';

export const BigLayerPanelComponent = ({
  onToggle,
  isExpanded = true,
  mapLegendImages = {},
  calculableBoundaryLayers = [],
  collapsedArrowIcon = '',
  expandedArrowIcon = '',
  activeLayerIds = [],
  onLayerToggle = () => {},
  calcPolygonSelections = [],
  calcPolygonLabelSelections = [],
  onCalculablePolygonChange = () => {},
  onCalculablePolygonLabelChange = () => {},
  demographicSelection = null,
  onDemographicChange = () => {},
  densitySelection = null,
  onDensityChange = () => {},
  onRetailerPointsToggle = () => {},
  proximitySelection = null,
  onProximityLayerToggle = () => {},
  onProximityRangeChange = () => {},
  onProximityPlaceChange = () => {},
  mapFilterParams = {},
  mapType = '',
  inspectionFailureRateSelection = null,
  onInspectionFailureRateMapFilter = () => {},
  campaignId = '',
}) => {
  const isArizona = IsAzAccount();
  const getMapLayerPanel = ({ isArizona, mapType }) => {
    if (isArizona) {
      switch (mapType) {
        case 'retailers':
          return (
            <ArizonaLayerPanel
              onToggle={onToggle}
              isExpanded={isExpanded}
              mapLegendImages={mapLegendImages}
              calculableBoundaryLayers={calculableBoundaryLayers}
              collapsedArrowIcon={collapsedArrowIcon}
              expandedArrowIcon={expandedArrowIcon}
              activeLayerIds={activeLayerIds}
              onLayerToggle={onLayerToggle}
              calcPolygonSelections={calcPolygonSelections}
              calcPolygonLabelSelections={calcPolygonLabelSelections}
              onCalculablePolygonChange={onCalculablePolygonChange}
              onCalculablePolygonLabelChange={onCalculablePolygonLabelChange}
              demographicSelection={demographicSelection}
              onDemographicChange={onDemographicChange}
              densitySelection={densitySelection}
              onDensityChange={onDensityChange}
              onRetailerPointsToggle={onRetailerPointsToggle}
              proximitySelection={proximitySelection}
              onProximityLayerToggle={onProximityLayerToggle}
              onProximityRangeChange={onProximityRangeChange}
              onProximityPlaceChange={onProximityPlaceChange}
              mapFilterParams={mapFilterParams}
              inspectionFailureRateSelection={inspectionFailureRateSelection}
              onInspectionFailureRateMapFilter={onInspectionFailureRateMapFilter}
            />
          );
        case 'retailers-public':
          return (
            <ArizonaPublicLayerPanel
              onToggle={onToggle}
              isExpanded={isExpanded}
              mapLegendImages={mapLegendImages}
              calculableBoundaryLayers={calculableBoundaryLayers}
              collapsedArrowIcon={collapsedArrowIcon}
              expandedArrowIcon={expandedArrowIcon}
              activeLayerIds={activeLayerIds}
              onLayerToggle={onLayerToggle}
              calcPolygonSelections={calcPolygonSelections}
              calcPolygonLabelSelections={calcPolygonLabelSelections}
              onCalculablePolygonChange={onCalculablePolygonChange}
              onCalculablePolygonLabelChange={onCalculablePolygonLabelChange}
              demographicSelection={demographicSelection}
              onDemographicChange={onDemographicChange}
              densitySelection={densitySelection}
              onDensityChange={onDensityChange}
              onRetailerPointsToggle={onRetailerPointsToggle}
              proximitySelection={proximitySelection}
              onProximityLayerToggle={onProximityLayerToggle}
              onProximityRangeChange={onProximityRangeChange}
              onProximityPlaceChange={onProximityPlaceChange}
              mapFilterParams={mapFilterParams}
              inspectionFailureRateSelection={inspectionFailureRateSelection}
              onInspectionFailureRateMapFilter={onInspectionFailureRateMapFilter}
            />
          );
        default:
          return (
            <ArizonaDefaultMapPanel
              onToggle={onToggle}
              isExpanded={isExpanded}
              mapLegendImages={mapLegendImages}
              calculableBoundaryLayers={calculableBoundaryLayers}
              collapsedArrowIcon={collapsedArrowIcon}
              expandedArrowIcon={expandedArrowIcon}
              activeLayerIds={activeLayerIds}
              onLayerToggle={onLayerToggle}
              calcPolygonSelections={calcPolygonSelections}
              calcPolygonLabelSelections={calcPolygonLabelSelections}
              onCalculablePolygonChange={onCalculablePolygonChange}
              onCalculablePolygonLabelChange={onCalculablePolygonLabelChange}
              demographicSelection={demographicSelection}
              onDemographicChange={onDemographicChange}
              campaignId={campaignId}
            />
          );
      }
    }

    return (
      <DefaultLayerPanel
        onToggle={onToggle}
        isExpanded={isExpanded}
        mapLegendImages={mapLegendImages}
        calculableBoundaryLayers={calculableBoundaryLayers}
        collapsedArrowIcon={collapsedArrowIcon}
        expandedArrowIcon={expandedArrowIcon}
        activeLayerIds={activeLayerIds}
        onLayerToggle={onLayerToggle}
        calcPolygonSelections={calcPolygonSelections}
        calcPolygonLabelSelections={calcPolygonLabelSelections}
        onCalculablePolygonChange={onCalculablePolygonChange}
        onCalculablePolygonLabelChange={onCalculablePolygonLabelChange}
        demographicSelection={demographicSelection}
        onDemographicChange={onDemographicChange}
      />
    );
  };

  return <>{getMapLayerPanel({ isArizona, mapType })}</>;
};
